const initialState = {
  rowData: null,
  action: null,
  page: null,
};

const pageData = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PAGE_DATA':
      return {
        ...state,
        rowData: action.payload.rowData,
        action: action.payload.action,
        page: action.payload.page,
      };
    default:
      return state;
  }
};

export default pageData;
